import Swiper from "swiper";
import { Autoplay, Pagination } from "swiper/modules";

export default class ReferencesTicker {
  constructor() {
    this.marquees = Array.from(document.querySelectorAll(".js-references-marquee"));
    this.mobileSliders = Array.from(document.querySelectorAll(".js-references-mobile-slider"));
    this.initMarquees();
    this.initMobileSliders();
  }

  initMarquees() {
    if (!this.marquees.length) return;

    const resize = () => {
      this.marquees.forEach((root) => this.syncMarqueeWidth(root));
    };

    window.addEventListener("resize", resize, { passive: true });
    window.addEventListener("load", resize, { passive: true });
    resize();
  }

  syncMarqueeWidth(root) {
    const track = root.querySelector(".js-references-marquee-track");
    const group = root.querySelector(".references-footer-marquee__group");
    if (!track || !group) return;

    const groupWidth = Math.round(group.getBoundingClientRect().width);
    if (!groupWidth) return;

    root.style.setProperty("--marquee-shift", `${groupWidth}px`);
  }

  initMobileSliders() {
    if (!this.mobileSliders.length) return;

    this.mobileSliders.forEach((sliderEl) => {
      const root = sliderEl.closest(".references-footer-mobile");
      const paginationEl = root?.querySelector(".js-references-mobile-pagination");
      const slideCount = sliderEl.querySelectorAll(".swiper-wrapper > .swiper-slide").length;
      const shouldLoop = slideCount > 3;

      if (sliderEl.swiper) {
        sliderEl.swiper.destroy(true, true);
      }

      new Swiper(sliderEl, {
        modules: [Pagination, Autoplay],
        slidesPerView: 3,
        spaceBetween: 8,
        speed: 420,
        grabCursor: true,
        watchOverflow: true,
        loop: shouldLoop,
        rewind: !shouldLoop,
        allowTouchMove: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        autoplay: {
          delay: 2600,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        breakpoints: {
          0: { slidesPerView: 3, spaceBetween: 8 },
          480: { slidesPerView: 3, spaceBetween: 10 },
          821: { slidesPerView: 4, spaceBetween: 12 },
        },
      });
    });
  }
}
